module.exports = __webpack_public_path__ + "img/w3_circle_down_grey.32c80c51.32c80c51.png";